import React, { useEffect, useState } from "react";
import { NavLink, withRouter, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { imageUrls } from "../../constants/images";
import { Icon } from "@iconify/react";
import InsideSearchIcon1 from "../../../assets/InsideSearchIcon1";
import InsideSearchIcon2 from "../../../assets/InsideSearchIcon2";
import { getProfileSession } from "../../redux/actions/dbactions/profileActions";
import { toast } from "react-toastify";
import { getSession } from "../../redux/actions/authActions";
import SideProfileIcon from "../../../assets/SideProfileIcon";
import "./sidebar.scss";

const Sidebar = ({
  handleShow,
  show,
  mobile,
  hideMobile,
  navigationLinks,
  searchQuery,
  setSearchQuery,
  setMobile,
}) => {
  const { profileData } = getProfileSession();
  const [showNoprofileMsg, setShowNoprofileMsg] = useState(true);
  const { profile } = useSelector((state) => state.profileReducer);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userFirstname, user_last_name } = getSession();

  // Manage hover state for each menu item
  const [hoveredItemId, setHoveredItemId] = useState(null);
  console.log("profileData", profileData);
  console.log(location.pathname)
  useEffect(() => {
    if (profileData) {
      if (
        profileData.user_has_profile_yn !== "Y" &&
        location.pathname !== "/dashboard/profile" &&
        showNoprofileMsg
      ) {
        history.push("/dashboard/profile");
        toast.error("Please fill your profile first");
        window.location.reload(); // Refresh the page
      }
    } else {
      if (location.pathname !== "/dashboard/profile" && showNoprofileMsg) {
        history.push("/dashboard/profile");
        window.location.reload();
        setShowNoprofileMsg(false);
      }
    }
  }, [profile, profileData, location.pathname, history, showNoprofileMsg]);

  const handleNavLinkClick = (e, url) => {
    if (
      profileData.user_has_profile_yn !== "Y" &&
      url !== "/dashboard/profile"
    ) {
      e.preventDefault();
      toast.error("Please fill your profile first to access other pages");
    } else {
      setMobile(!mobile);
    }
  };

  return (
    <div
      className={`side_nav z-[55] flex justify-between flex-col sidebarIn ${mobile && "sidebarOut"
        } `}
    >
      <div style={{ height: "100%" }}>
        <div className="nav_side flex items-center justify-between border-b border-[#E7E7E9]">
          <div className="w-40">
            <img
              src={imageUrls.logo}
              style={{ mixBlendMode: "darken" }}
              alt="logo"
            />
          </div>
          <div className="mobile_dev close_position">
            <Icon
              icon="system-uicons:cross"
              className="cursor-pointer"
              onClick={hideMobile}
            />
          </div>
        </div>
        <div className="my-4 flex items-center px-3">
          <form
            className="px-3 py-2 flex gap-2 h-8 rounded-md text-sm w-full border border-[##E1E1E1] bg-[#FAFAFB] text-[#4A4E5A] search"
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="iconamoon:search-thin"
              style={{ width: "20px", height: "15px" }}
            />
            <input
              type="text"
              placeholder="Search"
              className="w-full bg-transparent border-0 outline-0"
              autoFocus
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div>
              <InsideSearchIcon1 />
            </div>
            <div>
              <InsideSearchIcon2 />
            </div>
          </form>
        </div>
        <ul className="navigation-links">
          {navigationLinks.map((item, index) =>
            item.event ? (
              <li
                className="logout navigation-links_navLinks"
                key={item.id}
                onClick={handleShow}
              >
                <span>{item.icon}</span>
                <span>{item.title}</span>
              </li>
            ) : item.heading === "" ? (
              <NavLink
                to={item.url}
                key={item.id}
                exact
                onClick={(e) => handleNavLinkClick(e, item.url)}
                onMouseEnter={() => setHoveredItemId(item.id)}
                onMouseLeave={() => setHoveredItemId(null)}
                className="navigation-links_navLinks"
                style={{ position: "relative" }}
              >
                <li>
                  <span>{item.icon}</span>
                  <span>{item.title}</span>
                </li>
              </NavLink>
            ) : item.heading === "PAYMENTS" ? (
              <>
                {item.title === "Payout" && (
                  <div className="font-medium text-xs text-[#7A7A87] pl-4 mt-4 mb-2 navigation-links_subHeading">
                    <span>PAYMENTS</span>
                  </div>
                )}
                <NavLink
                  to={item.url}
                  key={item.id}
                  exact
                  onClick={(e) => handleNavLinkClick(e, item.url)}
                  // onMouseEnter={() => setHoveredItemId(item.id)}
                  // onMouseLeave={() => setHoveredItemId(null)}
                  className="navigation-links_navLinks"
                  style={{ position: "relative" }}
                >
                  <li>
                    <span>{item.icon}</span>
                    <span>{item.title}</span>
                    {item.title === "Payout" &&
                      // hoveredItemId === item.id &&
                      item.submenu && (
                        <ul className="submenu">
                          {item.submenu.map((sublink) => (
                            <NavLink to={sublink.url} key={sublink.id}>
                              <li>
                                <span>{sublink.icon} </span>
                                <span>{sublink.title}</span>
                              </li>
                            </NavLink>
                          ))}
                        </ul>
                      )}
                  </li>
                </NavLink>
              </>
            ) : (
              <>
                {item.title === "Messages" && (
                  <div className="font-medium text-xs text-[#7A7A87] pl-4 navigation-links_subHeading mb-2">
                    <span>OTHERS</span>
                  </div>
                )}
                <NavLink
                  to={item.url}
                  key={item.id}
                  exact
                  onClick={(e) => handleNavLinkClick(e, item.url)}
                  onMouseEnter={() => setHoveredItemId(item.id)}
                  onMouseLeave={() => setHoveredItemId(null)}
                  className="navigation-links_navLinks"
                  style={{ position: "relative" }}
                >
                  <li>
                    <span>{item.icon}</span>
                    <span>{item.title}</span>
                  </li>
                </NavLink>
              </>
            )
          )}
        </ul>
      </div>
    </div>
  );
};

export default withRouter(Sidebar);
